import { FlyerCampaign } from '../models/interfaces/FlyerCampaign.interface';
import backendCallerService from './backend-caller.service';
import { UrlUtils } from '../commons/utils/url.utils';

class FlyerCampaignService {
  public async getAllFlyerCampaigns(): Promise<FlyerCampaign[]> {
    const url = '/v1/flyer-campaign';

    const response = await backendCallerService.get(url);

    return response?.body;
  }

  public async prepareNewFlyerCampaign(
    address: string,
    radius: number,
    excludedBoIds: number[]
  ): Promise<FlyerCampaign> {
    const url = UrlUtils.addParameterToUrl('/v1/flyer-campaign/prepare', {
      address,
      radius,
      excluded: excludedBoIds?.length ? excludedBoIds?.join(',') : [],
    });

    const response = await backendCallerService.get(url);

    return response?.body;
  }

  public async refreshFlyerCampaign(flyerCampaignId: number): Promise<FlyerCampaign> {
    const url = `/v1/flyer-campaign/${flyerCampaignId}/refresh`;

    const response = await backendCallerService.get(url);

    return response?.body;
  }

  public async saveFlyerCampaign(flyerCampaign: FlyerCampaign): Promise<FlyerCampaign> {
    const url = '/v1/flyer-campaign/save';

    const response = await backendCallerService.post(url, flyerCampaign);

    return response?.body;
  }

  public async createInvoiceForFlyerCampaign(
    flyerCampaignId: number,
    invoiceItem: string,
    amount: number
  ): Promise<boolean> {
    const url = `/v1/flyer-campaign/${flyerCampaignId}/create-invoice`;

    const response = await backendCallerService.post(url, {
      name: invoiceItem,
      netAmount: amount,
    });

    return response?.status === 200;
  }

  public async sendFlyerCampaign(
    flyerCampaignId: number,
    numberCustomerToSend: number,
    businessObjectId: number
  ): Promise<FlyerCampaign> {
    const url = UrlUtils.addParameterToUrl(`/v1/flyer-campaign/${flyerCampaignId}/send`, {
      numberToSend: numberCustomerToSend,
      businessObjectId,
    });

    const response = await backendCallerService.post(url, {});

    return response?.body;
  }
}

const flyerCampaignService = new FlyerCampaignService();
export default flyerCampaignService;
